export const addiesaasReady = (callback, prepend) => {
  const ad = window.addiesaas || (window.addiesaas = {})
  const ready = ad.ready || (ad.ready = {callbacks: []})
  const callbacks = ready.callbacks
  const readyType = typeof ready
  if (readyType === 'function') {
    ready(callback)
  } else {
    if (prepend) {
      callbacks.unshift(callback)
    } else {
      callbacks.push(callback)
    }
  }
}

export const addiesaasBeforeReady = (callback, prepend) => {
  const ad = window.addiesaas || (window.addiesaas = {})
  const ready = ad.ready || (ad.ready = {callbacks: []})
  const callbacks = ad.beforeReady || (addiesaas.beforeReady = [])
  const readyType = typeof ready
  if (readyType === 'function') {
    ready(callback)
  } else {
    if (prepend) {
      callbacks.unshift(callback)
    } else {
      callbacks.push(callback)
    }
  }
}

export default {addiesaasBeforeReady, addiesaasReady}
